import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShareArrowDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"share-arrow-down, save"} maskId="square-filled-radius-0-stroke-1-IconShareArrowDown"><path fillRule="evenodd" clipRule="evenodd" d="M12.5 1H11.5V4H3V21H21V4H12.5V1ZM12.5 4H11.5V13.7929L8.5 10.7929L7.79289 11.5L12 15.7071L16.2071 11.5L15.5 10.7929L12.5 13.7929V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconShareArrowDown;
